// EquationGenerator.js
import React, { useState, useEffect } from "react";

export default function EquationGenerator() {
  const [equation, setEquation] = useState("");
  const [solution, setSolution] = useState(0);
  const [userAnswer, setUserAnswer] = useState("");
  const [feedback, setFeedback] = useState("");

  // Generate a new random equation & solution initially
  useEffect(() => {
    generateNewEquation();
    // eslint-disable-next-line
  }, []);

  function generateNewEquation() {
    // Random coefficients for the form: A(x + B) + C = x + D
    const A = Math.floor(Math.random() * 3) + 2; // 2..4
    const B = Math.floor(Math.random() * 6) - 3; // -3..2
    const C = Math.floor(Math.random() * 5) - 2; // -2..2
    const D = Math.floor(Math.random() * 6) - 3; // -3..2

    // Expand left side: A*x + A*B + C = x + D
    // => (A - 1)*x = D - (A*B + C)
    // => x = [D - (A*B + C)] / (A - 1)
    const leftCoeff = A - 1;
    const rightVal = D - (A * B + C);
    let sol = 0;
    if (leftCoeff !== 0) {
      sol = rightVal / leftCoeff;
    } else {
      // degenerate case if A=1, but we randomly set A 2..4, so it's rarely an issue
      sol = 0;
    }

    // Format the displayed equation
    const eqString = `${A}(x + ${B}) + ${C} = x + ${D}`;

    setEquation(eqString);
    setSolution(sol);
    setUserAnswer("");
    setFeedback("");
  }

  function checkAnswer() {
    const numeric = parseFloat(userAnswer);
    if (isNaN(numeric)) {
      setFeedback("Please enter a valid number.");
      return;
    }
    // Tolerance check for decimals
    const epsilon = 0.001;
    if (Math.abs(numeric - solution) < epsilon) {
      setFeedback("✅ Correct!");
    } else {
      setFeedback("❌ Try again!");
    }
  }

  return (
    <div style={{ border: "1px solid #ccc", padding: 10, borderRadius: 6 }}>
      <p>
        <strong>Equation:</strong> {equation}
      </p>

      <div style={{ marginBottom: 6 }}>
        <label>Proposed x: </label>
        <input
        className="inputBox"
          type="text"
          value={userAnswer}
          onChange={(e) => setUserAnswer(e.target.value)}
          style={{ width: 60, marginRight: 10 }}
        />
        <button className="button1" onClick={checkAnswer} style={{ marginRight: 10 }}>
          Check
        </button>
        <button className="button1" onClick={generateNewEquation}>New Equation</button>
      </div>

      {feedback && <p>{feedback}</p>}
    </div>
  );
}
